<div class="container-fluid" [hidden]="!status.error">
	<div class="row padding-top-10">
		<div class="col-xs-12" [ngClass]="styles.border">
			<div class="centered-copy">
				<div class="alert alert-danger">
					{{ 'UnhandledError' | translate }}
				</div>
			</div>
		</div>
	</div>
</div>

<vb-loading-spinner [hidden]="!status.processing" [block]="true" [size]="'large'">
</vb-loading-spinner>

<div class="container-fluid" [hidden]="!webcast.isPresentationProfileDeviceInactive">
	<div class="row padding-top-10">
		<div class="col-xs-12" [ngClass]="styles.border">
			<div class="centered-copy">
				<div class="alert alert-danger">
					<button type="button" class="close" (click)="closeWebcast()">&times;</button>
					<span class="glyphicons circle_exclamation_mark"></span>
					{{ 'Event_VideoSourceInactive' | translate }}
				</div>
			</div>
		</div>
	</div>
</div>

<div [hidden]="!status.active">
	<!--Starting Video Source indeterminate progress display for the event admin-->
	<div class="container-fluid" *ngIf="webcast.startingVideoSource
		&& webcast.isPresentationProfileType
		&& webcast.currentUser.isEventAdmin
		&& !webcast.enableLiveStreamStatusDisplay">
		<div class="row padding-top-10">
			<div class="col-xs-12" [ngClass]="styles.border">
				<vb-loading-bar class="centered-copy" [isLoading]="true">
					<h3>{{ 'Event_EncoderStillStarting' | translate }}</h3>
				</vb-loading-bar>
			</div>
		</div>
	</div>

	<div class="container-fluid" *ngIf="!webcast.startingVideoSource
			&& !webcast.currentUser.isEventModerator
			&& !webcast.enableLiveStreamStatusDisplay
			&& webcast.waitingForVideoSource">
		<div class="row padding-top-10">
			<div class="col-xs-12" [ngClass]="styles.border">
				<vb-loading-bar class="centered-copy" [isLoading]="true">
					<h3>{{ 'Event_WaitingForVideoSource' | translate }}</h3>
				</vb-loading-bar>
			</div>
		</div>
	</div>

	<div class="webcast" layout="column" flex-wrap="false" *ngIf="(!webcast.startingVideoSource && !webcast.waitingForVideoSource) || webcast.enableLiveStreamStatusDisplay" [ngClass]="{
			'webcast-wrap': !webcast.layout.isFullscreenVideo,
			'webcast-wrap-fs': webcast.layout.isFullscreenVideo
		}" [ngStyle]="{
			height: height
		}">

		<webcast-pre-prod-banner [hidden]="webcast.layout.isFullscreenVideo" [webcast]="webcast">
		</webcast-pre-prod-banner>

		<!-- these are the status messages -->
		<div class="webcast-status-msg" *ngIf="!webcast.layout.isFullscreenVideo && webcast.currentUser.isEventAdmin">
			<span class="event-message" *ngIf="statusMsg" [ngClass]="statusClass">
				{{ statusMsg }}
			</span>

			<span class="event-message warning fade-it-in" [hidden]="!(webcast.recording.isReconnecting)">
				{{ 'Event_RecordingReconnecting' | translate }}
			</span>
		</div>

		<!-- Navigation Bar -->
		<div>
			<webcast-nav *ngIf="viewContext.showNavBar && !webcast.layout.isFullscreenVideo" [webcast]="webcast" [webcastViewContext]="webcastViewContext" [previousState]="previousState" [backstageLayout]="webcast.producerOptions?.backstageLayout" [onStageLayout]="webcast.producerOptions?.onStageLayout" (onEndEvent)="leaveWebcast()">
			</webcast-nav>
		</div>

		<div class="position-relative" flex="fill" layout="column" [webcastBackground]="webcast.backgroundImages" [isBackgroundFill]="webcast.isBackgroundFill">
			<vb-ui-sidebar-layout class="webcast-body" *ngIf="webcast.currentRun.isStarted" [noBorder]="true" [ngClass]="[
					styles.sidebarLayout,
					webcast.currentUser.isEventAdmin ? 'presenter no-status-bar' : '',
					isSmallScreenSize && !!activeSidebarButtonId ? styles.sidebarOpenedInMobile : ''
				]" flex="1" layout="column" layout-gt-md="row" flex-wrap="false">


				<div layout="column" flex="fill" class="webcast-main-content theme-primary-font-border-fade-50" slot="mainContent" [ngClass]="{
						'vertical-layout': webcast.layout.isVertical,
						'no-presentation': !webcast.layout.isPresentationVisible || !viewContext.showPresentationSlides,
						'no-video': !webcast.layout.isVideoVisible,
						'no-slides': !webcast.layout.isPresentationSlidesVisible,
						'no-right-sidebar': !webcast.layout.isRightSidebarOpen
					}">

					<div *ngIf="showPresenterStatus" @fadeInOutAnimation [ngClass]="styles.statusPopup">
						<span class="glyphicons circle_exclamation_mark"></span>
						<div>
							{{ (webcast.isPresenterReady ? 'Event_PresenterIsReadyMsg' : 'Event_PresenterNotReadyMsg' ) | translate }}
							<span class="help-block" *ngIf="webcast.isPresenterReady">{{'Event_PresenterIsReadyMsg2' | translate}}</span>
						</div>
						<button type="button" [title]="'Close' | translate" (click)="showPresenterStatus = false">
							<span class="glyphicons remove_2"></span>
						</button>
					</div>

					<div flex="fill" [ngClass]="[
							styles.videoAndPresentationWrapper,
							webcast.currentUser.canControlPresentationSlides && webcast.layout.isPresentationSlidesVisible ? styles.videoAndPresentationWrapperWithSlides : ''
						]" *ngIf="webcast.layout.isBroadcastContentRendered">
						<div class="resize-fill viewer-content" layout="column" layout-gt-md="row" [hidden]="!webcast.layout.isBroadcastContentVisible">
							<vb-webcast-video [webcast]="webcast" [isStopped]="!webcast.layout.isBroadcastContentVisible" [fillVideo]="viewContext.focusVideo" [viewContext]="analyticsViewContext" (onPlayerReady)="onPlayerReady.emit($event)" layout-gt-md="column" flex="50" class="video-viewport" [ngClass]="{
									'webcast-video-hidden': !webcast.layout.isVideoVisible,
									'viewport-fs': webcast.layout.isFullscreenVideo
								}">
							</vb-webcast-video>

							<webcast-presentation [webcast]="webcast" layout-gt-md="column" [hideFullscreenPresentation]="viewContext.hideFullscreenPresentation" flex="50" [ngClass]="styles.presentationViewport" *ngIf="viewContext.showPresentationSlides && webcast.presentation.hasPresentation && !webcast.layout.isFullscreenVideo" [hidden]="!webcast.layout.isPresentationVisible">
							</webcast-presentation>
						</div>
					</div>
					<presenter-view *ngIf="webcast.currentUser.isSinglePresenter && webcast.isWebrtcSinglePresenter" [webcast]="webcast"></presenter-view>

					<producer-view *ngIf="webcast.currentUser.isPresenter && webcast.isProducerEvent && !isMobile" [webcast]="webcast"></producer-view>

					<div [ngClass]="styles.broadcastNotAvailable" *ngIf="!webcast.layout.isBroadcastContentVisible && !webcast.currentUser.isSinglePresenter && !webcast.currentUser.isPresenter">
						@if(!webcast.broadcast.isActive) {
							@if (webcast.broadcast.restarting()?.status) {
								<div class="theme-primary" [ngClass]="styles.playbackFetchingLoader">
									<vb-loading-spinner [size]="'large'" [block]="true" [iconClass]="'glyphicons wifi_alt'" [msg]="webcast.broadcast.restarting()?.message || 'Event_EventAdminNotBroadcastingWhenRestart' | translate" [msgDisplayBelowSpinner]="true">
									</vb-loading-spinner>
								</div>
							} @else {
								<div [ngClass]="[styles.eventNotStarted, !!webcast.backgroundImages ? 'theme-primary' : '']">
									<h2>{{ 'Event_EventAdminNotBroadcasting' | translate }}</h2>

									{{webcast.startDate| vbDateTimeMedium}} -
									{{webcast.endDate| vbDateTimeMedium}}

									<div [hidden]="!webcast.description" [ngClass]="styles.eventDescriptionWrapper" class="text-align-left theme-primary-font-border-fade-50" [innerHTML]="webcast.description | safeHtml">
									</div>
								</div>
							}
						} @else {
							<div [ngClass]="styles.playbackFetchingLoader">
								<vb-loading-spinner [size]="'large'" [block]="true" [iconClass]="'glyphicons wifi_alt'" [msg]="'LoadingStream' | translate" [msgDisplayBelowSpinner]="true">
								</vb-loading-spinner>
							</div>
						}
					</div>
					<div flex="256px" class="presentation-slides-wrapper" *ngIf="viewContext.showPresentationSlides && webcast.currentUser.canControlPresentationSlides" [hidden]="!(webcast.layout.isPresentationSlidesVisible && !webcast.layout.isFullscreenVideo)">
						<div layout-gt-md="column" class="presentation-slides d-none d-lg-block">
							<webcast-presentation-slides [webcast]="webcast"></webcast-presentation-slides>
						</div>
					</div>
				</div>
				<vb-ui-sidebar slot="sidebar" [hidden]="viewContext.hideSidebar" [themed]="true" (onToggle)="onToggleSidebar($event)" [defaultClickedButtonId]="isSmallScreenSize ? undefined : WebcastViewSidebarButton.INFO">
					<div slot="headerTitle">
						@switch(activeSidebarButtonId) {
							@case (WebcastViewSidebarButton.POLLS) {
								<div [ngClass]="styles.pollsSidebarPanelHeader">
									<span>
										{{ 'Event_PollsWithCount' | translate: { '0': webcast?.polls?.$polls?.length ?? 0 } }}
									</span>
								</div>
							}
							@case (WebcastViewSidebarButton.ATTENDEES) {
								@let attendeeCount = attendeeCount$ | async;
								<span>
									{{ 'Event_AttendeesWithCount' | translate: { '0': attendeeCount ?? 0 } }}
								</span>
							}
							@case (WebcastViewSidebarButton.BANNERS) {
								@let bannerCount = (webcast.webcast$ | async).bannerDetails?.banners?.length ?? 0;
								<span>
									{{ 'Event_Banners_WithCount' | translate: { '0': bannerCount } }}
								</span>
							}
						}
					</div>

					<div class="d-inline ms-2" slot="headerControls">
						@switch(activeSidebarButtonId) {
							@case (WebcastViewSidebarButton.INFO) {
								@if(webcast.currentUser.canEdit) {
									@if(!inlineEdit) {
										<button type="button" class="btn btn-transparent" [ngClass]="styles.editSettingsBtn" (click)="inlineEdit = true">
											<em class="vb-icon vb-icon-center vb-icon-pencil padding-right-5"></em>
											{{ 'EditSettings' | translate }}
										</button>
									} @else {
										<div class="margin-right-10">
											<button type="button" class="margin-right-10" (click)="inlineEdit = false" vbBtnSecondary>
												{{ 'Cancel' | translate }}
											</button>

											<button type="button" (click)="saveEdits()" [disabled]="editWebcastInvalid" vbBtnPrimary>
												{{ 'Save' | translate }}
											</button>
										</div>
										
									}
								}
							}
							@case (WebcastViewSidebarButton.QA) {
								@if(webcast.currentUser.canManageQuestions) {
									<a uiSref="webcast-fullscreen.manage-questions" [uiParams]="{webcastId: webcast.id}" target="_blank" [attr.aria-label]="'Event_QA_OpenNewWindow' | translate" class="text-decoration-none theme-primary-font-link" [ngClass]="styles.qaFullWindow">
										<span class="glyphicons new_window padding-right-5" [attr.title]="'Event_OpenInNewWindow' | translate"></span>
										<span>{{ 'Expand' | translate }}</span>
									</a>
								}
							}
							@case (WebcastViewSidebarButton.ATTENDEES) {
								<button type="button" class="btn btn-transparent" [ngClass]="styles.attendeeListRefreshBtn" [attr.aria-label]="(isAttendeeListPollingActive ? 'Event_AttendeesList_PauseUpdates' : 'Event_AttendeesList_ResumeUpdates') | translate" [title]="(isAttendeeListPollingActive ? 'Event_AttendeesList_PauseUpdates' : 'Event_AttendeesList_ResumeUpdates') | translate" (click)="isAttendeeListPollingActive = !isAttendeeListPollingActive;">
									<span class="vb-icon" [ngClass]="isAttendeeListPollingActive ? 'vb-icon-pause' : 'vb-icon-reset'">
									</span>
									<span [ngClass]="styles.attendeeListRefreshIconText">{{ (isAttendeeListPollingActive ? 'Pause' : 'Refresh') | translate }}</span>
								</button>
							}
						}
					</div>

					<webcast-view-sidebar-panel slot="panelBody" [accountId]="accountId" [webcast]="webcast" [sidebarNotifications]="sidebarNotifications" [webcastViewContext]="viewContext" [selectedButtonId]="activeSidebarButtonId" [inlineEdit]="inlineEdit" [isAttendeesPollingActive]="isAttendeeListPollingActive" (inlineEditCompleted)="inlineEdit=false" (sourceRestartInitiated)="onRestartWebcastSource($event)" (switchStreamInitiated)="onSwitchStream()">
					</webcast-view-sidebar-panel>

					<div slot="sidebarButtons">
						<vb-ui-sidebar-button [id]="WebcastViewSidebarButton.INFO" [headerLabel]="translationKeys.infoSidebarHeader | translate">
							<span class="vb-icon vb-icon-info"></span>
							<span class="btn-label">{{translationKeys.infoSidebarHeader | translate}}</span>
						</vb-ui-sidebar-button>
						@if(!this.isSmallScreenSize && this.webcast.currentUser.isEventAdminOrModerator) {
							<vb-ui-sidebar-button [id]="WebcastViewSidebarButton.RTA" [sref]="'webcast-analytics'" [srefOpts]="{ webcastId: webcast.id }">
								<span class="vb-icon vb-icon-realtime-analytics"></span>
								<span class="btn-label">{{'Event_RealTimeAnalytics_Dashboard' | translate}}</span>
							</vb-ui-sidebar-button>
						}
						@if(webcast.currentUser.canViewAttendees) {
							<vb-ui-sidebar-button [id]="WebcastViewSidebarButton.ATTENDEES">
								<span class="vb-icon vb-icon-user"></span>
								<span class="btn-label">{{'Event_Attendees' | translate}}</span>
							</vb-ui-sidebar-button>
						}
						@if(webcast.isChatEnabled()) {
							<vb-ui-sidebar-button [id]="WebcastViewSidebarButton.CHAT" [headerLabel]="'Event_GeneralChat' | translate">
								<span class="vb-icon vb-icon-chat"></span>
								<vb-ui-sidebar-notification [notification]="sidebarNotifications.chat">
								</vb-ui-sidebar-notification>
								<span class="btn-label">{{'Event_GeneralChat' | translate}}</span>
							</vb-ui-sidebar-button>
						}
						@if(webcast.isPollsEnabled()) {
							<vb-ui-sidebar-button [id]="WebcastViewSidebarButton.POLLS">
								<span class="vb-icon vb-icon-graph"></span>
								<vb-ui-sidebar-notification [notification]="sidebarNotifications.polls">
								</vb-ui-sidebar-notification>
								<span class="btn-label">{{'Event_Polls' | translate}}</span>
							</vb-ui-sidebar-button>
						}
						@if(webcast.isQuestionAndAnswerEnabled()) {
							<vb-ui-sidebar-button [id]="WebcastViewSidebarButton.QA" [headerLabel]="'Event_QuestionsAndAnswers' | translate">
								<span class="vb-icon vb-icon-q-and-a"></span>
								<vb-ui-sidebar-notification [notification]="sidebarNotifications.questions">
								</vb-ui-sidebar-notification>
								<span class="btn-label">{{'Event_QuestionsAndAnswers_Short' | translate}}</span>
							</vb-ui-sidebar-button>
						}
						@if(webcast.isProducerEvent &&
							ListenerConnection.isConnected() &&
							webcast.currentUser.isAssignedEventAdmin) {
							<vb-ui-sidebar-button [id]="WebcastViewSidebarButton.PRODUCER" [headerLabel]="'Event_Producer_ProductionDesign' | translate" [activeOnVisible]="true">
								<span class="vb-icon vb-icon-producer-design"></span>
								<span class="btn-label">{{'Event_Producer_ProductionDesign' | translate}}</span>
							</vb-ui-sidebar-button>
						}
						@if(webcast.isProducerEvent &&
							webcast.currentUser.isPresenter &&
							!isMobile) {
							<vb-ui-sidebar-button [id]="WebcastViewSidebarButton.PRODUCER_CONTROLS" [headerLabel]="'Event_Producer_AVSettings' | translate">
								<span class="vb-icon vb-icon-settings"></span>
								<span class="btn-label">{{'Event_Producer_AVSettings' | translate}}</span>
							</vb-ui-sidebar-button>
						}
						@if(webcast.isBannerEnabled() && webcast.currentUser.isEventAdminOrModerator) {
							<vb-ui-sidebar-button [id]="WebcastViewSidebarButton.BANNERS">
								<span class="vb-icon vb-icon-flag"></span>
								<span class="btn-label">{{'Banners' | translate}}</span>
							</vb-ui-sidebar-button>
						}
						@if(webcast.isEmbeddedContentEnabled() && webcast.currentUser.isEventAdminOrModerator) {
							<vb-ui-sidebar-button [id]="WebcastViewSidebarButton.EMBEDDED_CONTENT" [headerLabel]="'Event_Embed_Content' | translate">
								<span class="vb-icon vb-icon-picture-in-picture"></span>
								<span class="btn-label">{{'Event_Embed_Content' | translate}}</span>
							</vb-ui-sidebar-button>
						}
						@if(webcast.isDtmfEnabledSource && webcast.currentUser.isEventAdmin && webcast.vcDtmfControlsEnabled) {
							<vb-ui-sidebar-button [id]="WebcastViewSidebarButton.DTMF" [headerLabel]="'DTMF' | translate">
								<span class="vb-icon vb-icon-dialpad"></span>
								<span class="btn-label">{{'DTMF' | translate}}</span>
							</vb-ui-sidebar-button>
						}
						@if(webcast.isEmbeddedContentEnabled() && webcast.embeddedContent?.contentLinks) {
							@for(link  of webcast.embeddedContent.contentLinks; track $index) {
								@if(link.isEnabled) {
									<vb-ui-sidebar-button [id]="link.id" [headerLabel]="link.name">
										<span class="vb-icon" [ngClass]="'vb-icon-'+link.icon"></span>
										@if(embeddedContentNotifications[link.id]) {
											<vb-ui-sidebar-notification [notification]="embeddedContentNotifications[link.id]">
											</vb-ui-sidebar-notification>
										}
										<span class="btn-label">{{link.name}}</span>
									</vb-ui-sidebar-button>
								}
							}
						}


					</div>
				</vb-ui-sidebar>
			</vb-ui-sidebar-layout>
			<webcast-start-and-end-message [webcast]="webcast" [translationKeys]="translationKeys">
			</webcast-start-and-end-message>
		</div>
	</div>
</div>
